__turbopack_context__.v({
  "activeFocus": "list-item-module__ZdY2Ra__activeFocus",
  "checkCircle": "list-item-module__ZdY2Ra__checkCircle",
  "horizontal": "list-item-module__ZdY2Ra__horizontal",
  "item": "list-item-module__ZdY2Ra__item",
  "itemButton": "list-item-module__ZdY2Ra__itemButton",
  "itemWrapper": "list-item-module__ZdY2Ra__itemWrapper",
  "lineSelect": "list-item-module__ZdY2Ra__lineSelect",
  "selected": "list-item-module__ZdY2Ra__selected",
  "vertical": "list-item-module__ZdY2Ra__vertical",
});
